import instance from '../axios'

// New-episode reminder subscription for a show (the Remind Me bell on show
// pages). Fully independent from the watchlist.
export type ShowReminderItem = {
  tmdbShowId: number
  title: string
  posterPath?: string | null
}

const remindersApi = {
  getMine: () => instance.get<ShowReminderItem[]>('/reminders'),
  add: (item: ShowReminderItem) =>
    instance.post('/reminders', {
      TmdbShowId: item.tmdbShowId,
      Title: item.title,
      PosterPath: item.posterPath,
    }),
  remove: (tmdbShowId: number) => instance.delete(`/reminders/${tmdbShowId}`),
}

export default remindersApi
